import { CommitteeEmployee } from "../../../models/Committee";

export const getCommitteeEmployeeDisplayName = (ce: CommitteeEmployee) => {
  if (ce.employee) {
    return ce.employee.name;
  } else if (ce.oibEmployee) {
    return `${ce.oibEmployee.oib}, ${ce.oibEmployee.lastName}, ${ce.oibEmployee.firstName}`;
  }

  return "";
};

export const isEmployeeActive = (emp: CommitteeEmployee) => {
  return !emp.deactivationDate && emp.employee;
};

export const canEmployeeBeRemoved = (
  activeTo: Date | null,
  emp: CommitteeEmployee | null
) => {
  return !(activeTo || emp?.isPresident || emp?.hasDecision);
};

export const updateEmployeesWithPresident = (
  committeeData: CommitteeEmployee[],
  rowKeyId: CommitteeEmployee["rowKeyId"]
) => {
  return committeeData.map((val) => {
    val.isPresident = val.rowKeyId === rowKeyId;
    return val;
  });
};

export const generatingEditedEmployee = (
  editing: CommitteeEmployee,
  newCommitteeEmployee: CommitteeEmployee
) => {
  return {
    ...editing,
    oibEmployee: newCommitteeEmployee.oibEmployee,
    employee: newCommitteeEmployee.employee,
    deactivationDate: newCommitteeEmployee.deactivationDate,
  };
};
